var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SoliForm", {
    ref: "dialog",
    attrs: { title: "New Automation", text: "Add to Automation" },
    on: {
      reset: function ($event) {
        return _setup.reset(true)
      },
      submit: function ($event) {
        return _setup.enroll()
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "contents" }, [
              _c(
                "div",
                { staticClass: "flex flex-col gap-4" },
                [
                  _c("v-select", {
                    attrs: {
                      items: [_vm.crmClient, ..._vm.relationships],
                      rules: [(v) => !!v || "Student is required"],
                      "error-messages": _vm.errors.studentable_id,
                      "item-value": "id",
                      "item-text": "name",
                      label: "Student",
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                      "return-object": "",
                    },
                    model: {
                      value: _setup.form.student,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "student", $$v)
                      },
                      expression: "form.student",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    staticClass: "soli-grey",
                    attrs: {
                      items: _setup.uniqueCampaignsbyNameAndCategory,
                      loading: _setup.campaignsLoading,
                      rules: [(v) => !!v || "Campaign is required"],
                      dense: "",
                      outlined: "",
                      "return-object": "",
                      "item-value": "group",
                      "item-text": "name",
                      label: "Campaign",
                      "no-data-text": "No campaigns available",
                      "hide-details": "auto",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.handleCampaignSelect($event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _vm._v(" "),
                                _c("v-list-item-subtitle", [
                                  _vm._v(
                                    _vm._s(
                                      `${item.category} | ${item.duration} days`
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _setup.form.campaign,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "campaign", $$v)
                      },
                      expression: "form.campaign",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _setup.programs,
                      loading: _setup.campaignLoading,
                      "item-value": "id",
                      "item-text": "title",
                      clearable: "",
                      label: "Program",
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    on: {
                      input: function ($event) {
                        return _setup.setCampaignFromProgram($event)
                      },
                    },
                    model: {
                      value: _setup.form.program_id,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "program_id", $$v)
                      },
                      expression: "form.program_id",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _setup.instruments,
                      loading: _setup.campaignLoading,
                      "item-value": "id",
                      "item-text": "name",
                      clearable: "",
                      label: "Instrument",
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    model: {
                      value: _setup.form.instrument_id,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "instrument_id", $$v)
                      },
                      expression: "form.instrument_id",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      items: _setup.messages,
                      loading: _setup.campaignLoading,
                      rules: [(v) => !!v || "Starting day is required"],
                      "item-value": "day_offset",
                      "item-text": "day_offset",
                      label: "Starting Day",
                      dense: "",
                      outlined: "",
                      "hide-details": "auto",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "v-select__selection v-select__selection--comma",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(`Day ${item.day_offset}`) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "item",
                        fn: function ({ item }) {
                          return [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v(_vm._s(`Day ${item.day_offset}`)),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _setup.form.day_offset,
                      callback: function ($$v) {
                        _vm.$set(_setup.form, "day_offset", $$v)
                      },
                      expression: "form.day_offset",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }